import React from 'react';
import PropTypes from 'prop-types';
import { Marker, InfoWindow } from 'react-google-maps';
import formatCoordinate from './helpers/formatCoordinate';

function createMarkup(html) {
    return { __html: html };
}

const MapMarker = (props) => {
    const icon = {
        url: props.image,
        size: new window.google.maps.Size(
            Math.floor(props.width / 2),
            Math.floor(props.height / 2),
        ), // half the actual size (squeezed), otherwise the info window is not centered correctly
        scaledSize: new window.google.maps.Size(
            Math.floor(props.width / 2),
            Math.floor(props.height / 2),
        ),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(
            Math.floor(props.width / 4),
            Math.floor(props.height / 2),
        ),
    };

    let { lat, lng } = props;

    if (typeof props.lat === 'string' || typeof props.lng === 'string') {
        lat = formatCoordinate(props.lat);
        lng = formatCoordinate(props.lng);
    }

    return (
        <Marker
            position={{ lat, lng }}
            icon={props.image ? icon : null}
            onClick={() => {
                if (props.toggleLocation) {
                    props.toggleLocation(props.id);
                }
            }}
        >
            {props.isOpen && (
                <InfoWindow
                    onCloseClick={() => {
                        if (props.toggleLocation) {
                            props.toggleLocation(props.id);
                        }
                    }}
                >
                    <div
                        dangerouslySetInnerHTML={createMarkup(props.infoBoxContent)}
                    />
                </InfoWindow>
            )}
        </Marker>
    );
};

MapMarker.defaultProps = {
    image: '',
    isOpen: false,
    infoBoxContent: '',
    toggleLocation: null,
};

MapMarker.propTypes = {
    id: PropTypes.number.isRequired,
    image: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    lat: PropTypes.any.isRequired,
    lng: PropTypes.any.isRequired,
    isOpen: PropTypes.bool,
    infoBoxContent: PropTypes.string,
    toggleLocation: PropTypes.func,
};

export default MapMarker;



// WEBPACK FOOTER //
// ./static/js/modules/locations-finder/Marker.js